import { Context } from "@nuxt/types/app";
import { get } from "lodash-es";

interface HasPermission {
  hasPermission(permission: string): boolean;
}

export default function (context: Context): HasPermission {
  function hasPermission(permission: string): boolean {
    const permissions =
      get(context.store.getters["auth/getUserData"], "permissions", []) || [];
    const permissionsLowerCase = permissions.map((item: string) =>
      item.toLowerCase(),
    );

    return permissionsLowerCase.includes((permission || "").toLowerCase());
  }

  return { hasPermission };
}
